// extracted by mini-css-extract-plugin
export default {"container":"client_container__5SC8+","first":"client_first__QyOUF","btn":"client_btn__a7jQa","all":"client_all__HEm+1","client":"client_client__VSdOK"};